import React from "react";
import { TitleFieldProps } from "@rjsf/utils";
import { Title } from "../../Common/Typography";
import { HeaderWrapper } from "./__styles__/TitleFieldTemplate";

export const TitleFieldTemplate = (props: TitleFieldProps) => {
  const { id, title, uiSchema } = props;
  const size = uiSchema?.["ui:heading"] === "h1" ? "large" : "default";

  return (
    <HeaderWrapper size={size}>
      <Title id={id} type="regular" size={size}>
        {title}
      </Title>
    </HeaderWrapper>
  );
};
